export default function PageLoader() {
    return (
        <div className="PageLoader h-screen justify-center items-center">
           <div className="flex justify-center items-center h-screen">
                <div className="rounded-full h-20 w-20 bg-yellow-primary animate-ping"></div>
            </div>
        </div>
    )
}